import { useState } from 'react';
import { Shell } from '../../components/layout/Shell.jsx';
import { Bar } from '../../components/ui/Bar.jsx';
import { Btn } from '../../components/ui/Btn.jsx';
import { Card } from '../../components/ui/Card.jsx';
import { ACCESS_ROLE } from '../../lib/access';
import { today } from '../../lib/utils';
import { C } from '../../theme/palette';

export function SuggestionsPage({ onNav, soc, setSoc, estMixte, univers, setUnivers }) {
  const [txt, setTxt] = useState('');
  const sugs = (soc && soc.suggestions) || [];
  const send = () => {
    if (!txt.trim()) {
      try {
        window.alert("Écris ta suggestion d'abord.");
      } catch (e) {}
      return;
    }
    setSoc((p) => ({
      ...p,
      suggestions: [
        {
          id: Date.now(),
          texte: txt.trim(),
          date: today(),
          par: typeof ACCESS_ROLE !== 'undefined' ? ACCESS_ROLE : 'utilisateur',
        },
        ...((p && p.suggestions) || []),
      ],
    }));
    setTxt('');
    try {
      window.alert('✓ Merci ! Ta suggestion a bien été enregistrée.');
    } catch (e) {}
  };
  const suppr = (id) => {
    setSoc((p) => ({ ...p, suggestions: ((p && p.suggestions) || []).filter((x) => x.id !== id) }));
  };
  return (
    <Shell
      active="plus"
      onNav={onNav}
      soc={soc}
      back
      onBack={() => onNav('plus')}
      pageTitle="💡 Suggestions"
      estMixte={estMixte}
      univers={univers}
      setUnivers={setUnivers}
    >
      <Card style={{ marginBottom: 12 }}>
        <Bar
          icon="💡"
          title="Proposer une amélioration"
          color={C.teal}
          sub="Ton idée aide à améliorer SwissTech"
        />
        <div style={{ padding: 13 }}>
          <textarea
            value={txt}
            onChange={(e) => setTxt(e.target.value)}
            rows={4}
            placeholder="Ex : j'aimerais pouvoir... / il manque... / ce serait bien si..."
            style={{
              width: '100%',
              boxSizing: 'border-box',
              border: '1px solid ' + C.border,
              borderRadius: 10,
              padding: 11,
              fontSize: 13,
              resize: 'vertical',
              fontFamily: 'inherit',
            }}
          />
          <div style={{ marginTop: 8 }}>
            <Btn label="📤 Envoyer ma suggestion" color={C.teal} full onClick={send} />
          </div>
        </div>
      </Card>
      <Card>
        <Bar icon="📋" title="Suggestions reçues" color={C.navy} sub={sugs.length + ' idée(s)'} />
        <div style={{ padding: 13 }}>
          {sugs.length === 0 ? (
            <div style={{ textAlign: 'center', color: C.muted, fontSize: 11, padding: 14 }}>
              Aucune suggestion pour l'instant. Les idées des utilisateurs s'afficheront ici.
            </div>
          ) : (
            sugs.map((sg) => (
              <div
                key={sg.id}
                style={{
                  borderBottom: '1px solid #f0f2f5',
                  padding: '10px 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                  gap: 10,
                }}
              >
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 12, color: C.ink, lineHeight: 1.5 }}>{sg.texte}</div>
                  <div style={{ fontSize: 8.5, color: C.muted, marginTop: 4 }}>
                    👤 {sg.par} · {sg.date}
                  </div>
                </div>
                <span
                  onClick={() => suppr(sg.id)}
                  style={{ cursor: 'pointer', color: C.muted, fontSize: 14, flexShrink: 0 }}
                >
                  🗑️
                </span>
              </div>
            ))
          )}
        </div>
      </Card>
      <div style={{ fontSize: 8.5, color: C.muted, textAlign: 'center', margin: '10px 0 4px' }}>
        Les suggestions sont enregistrées dans l'app. Le patron les consulte ici.
      </div>
    </Shell>
  );
}
